export function initMobileNav() {
  const openBtn = document.querySelector("[data-menu-open]");
  const closeBtn = document.querySelector("[data-menu-close]");
  const panel = document.querySelector("[data-mobile-nav]");
  if (!openBtn || !closeBtn || !panel) return;

  let lastFocused = null;

  const getFocusable = () =>
    Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );

  function openMenu() {
    lastFocused = document.activeElement;
    panel.setAttribute("data-open", "true");
    openBtn.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    const focusable = getFocusable();
    focusable[0]?.focus();
  }

  function closeMenu() {
    panel.setAttribute("data-open", "false");
    openBtn.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    lastFocused?.focus();
  }

  openBtn.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);

  panel.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeMenu();
      return;
    }
    if (e.key === "Tab") {
      const focusable = getFocusable();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Close on nav link click (single page navigation)
  panel.querySelectorAll("a").forEach((link) =>
    link.addEventListener("click", closeMenu)
  );
}
